import { DateTime } from 'luxon'
import { CumulativeRainfallIntensity } from './CumulativeRainfallIntensity'
import { ITimeAndCityLocalizable } from './ITimeAndCityLocalizable'
import { Representation } from './Representation'
import { TimeStep } from './TimeStep'

export class TimeStepCumulativeRainfall extends TimeStep {
  constructor(
    snapshot: ITimeAndCityLocalizable,
    timestamp: DateTime,
    readonly cumulativeRainfallIntensity: Map<number, CumulativeRainfallIntensity>,
  ) {
    super(snapshot, timestamp)
  }

  getValue(representation: Representation<'cumulative rainfall'>): number {
    const value = this.cumulativeRainfallIntensity.get(representation.cumulativeRainfall.cumulativeTimeMinutes)
    if (!value)
      throw Error(
        `missing cumulative rainfal for rainfall: ${representation.cumulativeRainfall.cumulAgregationTimeMinutes}`,
      )

    return value.maxIntensity
  }

  public isEmpty(): boolean {
    return this.cumulativeRainfallIntensity.size === 0
  }

  public hasCumulativeRainfallIntensityByRainfall(cumulativeRainfall: number): boolean {
    if (this.cumulativeRainfallIntensity === undefined) {
      return false
    }
    return this.cumulativeRainfallIntensity.has(cumulativeRainfall)
  }
}
